(function () {
  'use strict';

  angular.module('app').component('taxList', taxList());

  function taxList() {
    return {
      bindings: {
        taxes: '=',
        meta: '<',
        totalItems: '=',
        taxTypes: '<',
      },
      controller: TaxListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/taxes/tax-list/tax-list.component.html',
    };
  }

  TaxListComponent.$inject = ['UtilService', 'AbilityService', 'SessionService', 'TaxService'];

  function TaxListComponent(UtilService, AbilityService, SessionService, TaxService) {
    const vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_tax_accountadmin'), //,
      // canUpdate:  AbilityService.can('update_tax_accountadmin'),
      // canDestroy: AbilityService.can('destroy_tax_accountadmin')
    };

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = TaxService.getFilterCriteria();

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showTax = showTax;

    vm.$onInit = function () {
      vm.atvCrEnabled = SessionService.getSelectedAccountCompany().atv_cr_enabled;

      vm.taxes = TaxService.setTaxes(vm.taxes, vm.taxTypes);
    };

    function fetchResult() {
      vm.loadingTaxes = true;
      TaxService.getTaxes(vm.filterCriteria).then(function (data) {
        vm.taxes = data.setTaxes(data.items, vm.taxTypes);
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;
        vm.loadingTaxes = false;
      });
    }

    function refresh() {
      vm.filterCriteria = TaxService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;

      fetchResult();
    }

    function showTax(tax) {
      if (!vm.permissions.canShow) {
        return;
      }

      let successCallBack = function (response) {
        // Change status / Delete
        if (response === 'changed') {
          fetchResult();
          return;
        }

        tax.taxType = vm.UtilService.findItemInArray(vm.taxTypes, 'code', tax.tax_type);

        tax.tax_rates = response.tax_rates;

        if (vm.atvCrEnabled) {
          tax.tax_rate_code = response.tax_rate_code;
        }

        vm.taxes = TaxService.getTodaysRate(vm.taxes);
      };

      TaxService.openTaxDetailModal(tax, 'view', vm.taxTypes, successCallBack);
    }
  }
})();
